import { Wallet, CreditCard } from "lucide-react";
import { Input } from "@/shared/components/ui/input";
import { SectionCard, FormRow } from "./DepositUI";
import PaymentMethodSelector from "@/shared/components/merchant/PaymentMethodSelector";

export default function MethodAmountSection({
  form,
  updateField,
  fieldRefs,
  errors,
  currency,
  currencySymbol,
}) {
  return (
    <div className="space-y-6">
      {/* Section 1 — Platform selector */}
      <SectionCard icon={Wallet} title="Platform">
        <PaymentMethodSelector
          selectedId={form.platformName}
          onSelect={(id) => updateField("platformName", id)}
          error={errors.platformName}
          fieldRef={(el) => (fieldRefs.current.platformName = el)}
        />
      </SectionCard>

      {/* Section 2 — Deposit amount */}
      <SectionCard icon={CreditCard} title="Amount">
        <FormRow
          id="amount"
          label={`Amount (${currency}) *`}
          error={errors.amount}
        >
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 font-medium">
              {currencySymbol}
            </span>
            <Input
              ref={(el) => (fieldRefs.current.amount = el)}
              id="amount"
              type="text"
              inputMode="decimal"
              value={form.amount}
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*\.?\d{0,2}$/.test(val) || val === "")
                  updateField("amount", val);
              }}
              placeholder="0.00"
              className="text-lg pl-10 h-12 rounded-xl"
            />
          </div>
        </FormRow>
      </SectionCard>
    </div>
  );
}
